export const VISIT_COMMENT_PF = 'VisitComment';

// Столько строк комментария видно в свёрнутом виде; всё, что длиннее,
// сокращается и раскрывается кнопкой «Показать полностью» (ТЗ us/11241).
export const VISIT_COMMENT_COLLAPSED_ROWS = 3;
